// The single place App.js asks "is this module unlocked?".
//
// Deliberately a module-level value rather than a React context: App.js is one
// 28 000-line file with no provider to hang a context off, and the portal is
// lazily imported only AFTER DemoBoot has resolved the licence — so the plan is
// already known and fixed by the time anything reads it. Upgrading reloads the
// page, so there is no in-session mutation to re-render for.
//
// Fails closed: until DemoBoot sets a plan, everything gated is locked.

// Extension is explicit so Node can load this file directly for
// scripts/test-license.mjs; webpack resolves it the same either way.
import { PLAN, PLAN_FEATURES } from "./plans.js";

let currentPlan = PLAN.FREE;
let currentDaysLeft = null;

export function setDemoPlan(plan, daysLeft) {
  currentPlan = plan || PLAN.FREE;
  currentDaysLeft = daysLeft ?? null;
}

export const demoPlan = () => currentPlan;
export const demoDaysLeft = () => currentDaysLeft;
export const isFreePlan = () => currentPlan === PLAN.FREE;

/** True when the current plan includes this feature. */
export function canUse(feature) {
  return (PLAN_FEATURES[currentPlan] || []).includes(feature);
}

// ── Opening the upgrade card from inside the portal ─────────────────────────
// A locked module stays visible in the menu, dimmed and padlocked, and clicking
// it should offer the trial rather than doing nothing. The card itself lives in
// DemoBoot, outside App.js — this is the one wire between them, so the portal
// source needs no knowledge of the demo's licensing UI.
let upgradeHandler = null;

/** DemoBoot registers the opener; returns an unsubscribe. */
export function onUpgradeRequest(fn) {
  upgradeHandler = fn;
  return () => {
    if (upgradeHandler === fn) upgradeHandler = null;
  };
}

/** Called from App.js when someone clicks a locked module. No-op off-demo. */
export function requestUpgrade() {
  if (upgradeHandler) upgradeHandler();
}
